import { useEffect, useState } from 'react';

import { OnlineSchedulingTabContent } from '@/design-system/molecules/OnlineScheduling/OnlineSchedulingTabContent';

/**
 * useOnlineSchedulingTabs hook
 *
 * Iterates based on component's data and return an array of tabs
 */
const useOnlineSchedulingTabs = (props) => {
    const [tabs, setTabs] = useState([]);
    const {
        acceptingNewPatients,
        body,
        containerId,
        cta,
        newPatientBody,
        newPatientSubtitle,
        subTitle,
        title,
        available,
        newPatientNoAvailabilityText,
    } = props;

    useEffect(
        function onlineScheduleTabsDataIterator() {
            const dynamicTabsArray = [];
            // Slice the array if not acceptingNewPatients
            const tabsIterator = acceptingNewPatients ? 2 : 1;
            // Dynamically create the tabs
            for (let i = 0; i < tabsIterator; i++) {
                let tab = {
                    id: `tab-${i + 1}`,
                };

                dynamicTabsArray.push(tab);
            }

            // Appending data to tabs
            dynamicTabsArray?.length &&
                dynamicTabsArray.forEach((tab) => {
                    if (dynamicTabsArray.length >= 2) {
                        if (tab.id === 'tab-1') {
                            tab['title'] = newPatientSubtitle;
                            tab['titleAriaLabel'] = newPatientSubtitle;
                            tab['content'] = (
                                <OnlineSchedulingTabContent
                                    isNewPatient
                                    tabBody={newPatientBody}
                                    acceptingNewPatients={acceptingNewPatients}
                                    containerId={containerId}
                                    available={available}
                                    noAvailabilityText={newPatientNoAvailabilityText}
                                />
                            );
                        } else if (tab.id === 'tab-2') {
                            tab['title'] = subTitle;
                            tab['titleAriaLabel'] = subTitle;
                            tab['content'] = (
                                <OnlineSchedulingTabContent
                                    tabBody={body}
                                    acceptingNewPatients={acceptingNewPatients}
                                    cta={cta}
                                />
                            );
                        }
                    } else {
                        tab.title = subTitle;
                        tab.titleAriaLabel = subTitle;
                        tab['content'] = (
                            <OnlineSchedulingTabContent
                                tabBody={body}
                                acceptingNewPatients={acceptingNewPatients}
                                cta={cta}
                            />
                        );
                    }
                });

            setTabs(dynamicTabsArray);
        },
        [
            acceptingNewPatients,
            body,
            containerId,
            cta,
            newPatientBody,
            newPatientSubtitle,
            subTitle,
            title,
            available,
            newPatientNoAvailabilityText,
        ],
    );

    return { tabs };
};

export default useOnlineSchedulingTabs;
